import { Components, Theme } from '@mui/material/styles';

// 0px is default from @mui
const distance = '-2px';

export const flowBadge: Components<Theme>['MuiBadge'] = {
  defaultProps: {
    color: 'error',
    slotProps: {
      root: {
        // disable aria-label, we place it on the badge instead
        ['aria-label']: null,
      },
      badge: ({ invisible, ...rest }) => ({
        ...(invisible
          ? {
              ['aria-hidden']: true,
            }
          : {
              ['aria-live']: 'polite',
              ['aria-atomic']: true,
            }),
        // pass aria-label to badge from parent
        ...(rest['aria-label'] && {
          ['aria-label']: rest['aria-label'],
        }),
      }),
    },
  },
  styleOverrides: {
    standard: {
      height: '16px',
      minWidth: '16px',
      fontSize: '10px',
      fontWeight: 'bold',
      borderRadius: '20px',
      padding: '0 4px',
    },
    dot: {
      height: '12px',
      width: '12px',
      borderRadius: '50%',
    },
    anchorOriginTopRightRectangular: {
      top: distance,
      right: distance,
    },
    anchorOriginTopLeftRectangular: {
      top: distance,
      left: distance,
    },
    anchorOriginBottomRightRectangular: {
      bottom: distance,
      right: distance,
    },
    anchorOriginBottomLeftRectangular: {
      bottom: distance,
      left: distance,
    },
  },
};
